import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, Secondary, Text } from "@cinch-labs/design-system";
import Image from "next/image";
import styles from "./careers.module.css";
export var CareersSection = function(blok) {
    var heading = blok.heading, body = blok.body, image = blok.image;
    var ref = _sliced_to_array((blok === null || blok === void 0 ? void 0 : blok.CTA) || [], 1), CTA = ref[0];
    var _alt;
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.wrapper,
        children: [
            (image === null || image === void 0 ? void 0 : image.filename) ? /*#__PURE__*/ _jsx("div", {
                className: styles.imageWrapper,
                children: /*#__PURE__*/ _jsx(Image, {
                    src: image.filename,
                    alt: (_alt = image.alt) !== null && _alt !== void 0 ? _alt : undefined,
                    layout: "fill",
                    objectFit: "cover"
                })
            }) : null,
            /*#__PURE__*/ _jsxs("div", {
                className: styles.textWrapper,
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        className: styles.heading,
                        children: heading
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        className: styles.body,
                        children: body
                    }),
                    CTA ? /*#__PURE__*/ _jsx(Secondary, {
                        element: "a",
                        href: CTA.url,
                        classNames: {
                            button: styles.button
                        },
                        children: CTA.text
                    }) : null
                ]
            })
        ]
    });
};
export default CareersSection;
